export const AiError = {
  NOT_INITIALIZED: {
    code: 'AI-01',
    defaultMessage:
      'AI module has not been initialized. Call initAiModule first.',
  },
  ALREADY_INITIALIZED: {
    code: 'AI-02',
    defaultMessage: 'AI module is already initialized.',
  },
  MISSING_API_KEY: {
    code: 'AI-03',
    defaultMessage: 'OPENROUTER_API_KEY is required.',
  },
  GENERATION_FAILED: {
    code: 'AI-05',
    defaultMessage: 'AI generation failed.',
  },
  RATE_LIMIT_EXCEEDED: {
    code: 'AI-06',
    defaultMessage: 'AI provider rate limit exceeded.',
  },
  INVALID_RESPONSE: {
    code: 'AI-07',
    defaultMessage: 'AI response could not be parsed.',
  },
  DECISIONS_FAILED: {
    code: 'AI-08',
    defaultMessage: 'Jev decisions request failed.',
  },
  INVALID_DECISIONS_INPUT: {
    code: 'AI-09',
    defaultMessage: 'Jev decisions input is invalid.',
  },
} as const;
